import { render, staticRenderFns } from "./VTabs.vue?vue&type=template&id=373226f7"
import script from "./VTabs.js?vue&type=script&lang=js&external"
export * from "./VTabs.js?vue&type=script&lang=js&external"
import style0 from "./VTabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
